export default class Params{

  static enviroment = 'pro';

  static url = {
    dev: 'http://admin.prismap.com.devel/app',
    pro: 'https://administrador.prismap.co/app'
  }

  static api = this.url[this.enviroment];

}